/**
 * Employee Web — authenticated index redirect.
 *
 * Phase 2 Plan 02-11: redirects to `/me` (the home placeholder) or honors a
 * deep-link `?redirect=<safe-path>` if present. `safeRedirectPath` returns
 * "/" for invalid candidates (never null); we only honor candidates that
 * survive the filter unchanged so an attacker-controlled redirect can never
 * force us past the `/me` landing.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { safeRedirectPath } from "@linkhr/auth";

export const Route = createFileRoute("/_auth/")({
  beforeLoad: ({ search }) => {
    const redirectParam = (search as { redirect?: string }).redirect;
    if (typeof redirectParam === "string") {
      const safe = safeRedirectPath(redirectParam);
      if (safe !== "/" && safe !== "" && safe === redirectParam) {
        throw redirect({ to: safe });
      }
    }
    throw redirect({ to: "/me" });
  },
});
